import { render, staticRenderFns } from "./vehicleedit.vue?vue&type=template&id=28bac568&scoped=true&"
import script from "./vehicleedit.vue?vue&type=script&lang=js&"
export * from "./vehicleedit.vue?vue&type=script&lang=js&"
import style0 from "./vehicleedit.vue?vue&type=style&index=0&id=28bac568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bac568",
  null
  
)

export default component.exports